<template>
    <div class="modal fade" :id="'openQuestionResponsesModal' + question._id" tabindex="-1" role="dialog" aria-labelledby="openQuestionResponsesModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header" style="padding-bottom: 0;">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <img src="./../../assets/ics.svg" alt="ics" />
                    </button>
                </div>
                <div class="modal-body" style="padding-top: 0;">
                    <div class="row">
                        <div class="col-12 margin-top-10 margin-bottom-20">
                            <h5 class="modal-ansewrs-title">(Q{{questionIndex}}) {{question.text}}</h5>
                        </div>
                        <div class="col-12 locations-scroll-container">
                            <div v-if="answers.length > 0" v-for="(answer) in answers" class="answers-list">
                                <span>{{answer}}</span>
                                <hr />
                            </div>
                            <div v-else class="answers-list">{{ $t('campaign_reports.no_results_found') }}</div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="row w-100">
                        <div class="col-12 margin-bottom-5 text-align-center">
                            <span data-dismiss="modal" class="modal-footer-canvassing-orange-button cursor-pointer">{{ $t('campaign_reports.close') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "OpenQuestionResponsesModal",
        props: ["question", "index"],
        mixins: [HelperMixin],
        data() {
            return {
                stopLoad: false,
                page: 1,
                answers: [],
            }
        },
        created() {

        },
        mounted() {
            let _this = this;
            $('#openQuestionResponsesModal' + this.question._id).on('shown.bs.modal', function(){
                if(_this.page == 1) {
                    _this.viewOpenQuestionResponses(_this.page);
                }
            });

            $('#openQuestionResponsesModal' + this.question._id + ' .locations-scroll-container').scroll(function() {
                if (_this.stopLoad != true) {
                    let div = $(this).get(0);
                    if(div.scrollTop + div.clientHeight >= div.scrollHeight) {
                        _this.viewOpenQuestionResponses(_this.page);
                    }
                }
            });
        },
        methods: {
            viewOpenQuestionResponses(page = 1) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });

                let config = {
                    headers: {
                        'Authorization': `Bearer ${this.$store.getters["token"]}`,
                    }
                };

                let sendData = {
                    page: page
                }

                axios.post(
                    '/api/v1/campaign/' + this.$route.params.campaign_id + '/question/' + this.question._id + '/answers',
                    sendData,
                    config
                ).then(this.consumeViewOpenQuestionResponses, this.errorViewOpenQuestionResponses);

                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
            },
            consumeViewOpenQuestionResponses(response) {
                if (this.page == 1) {
                    this.answers = response.data.data.data;
                } else {
                    this.answers = this.answers.concat(response.data.data.data);
                }

                this.page = this.page + 1;
                if (this.page > response.data.data.last_page) {
                    this.stopLoad = true;
                }

                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
            },
            errorViewOpenQuestionResponses: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                console.log(error);
            }
        },
        computed: {
            questionIndex() {
                return this.index+1;
            }
        }
    };
</script>